export default [
  {
    path: '/index-complaint',
    name: 'index-complaint',
    component: () => import('@/views/complaint/IndexComplaint.vue'),
    meta: {
      title: 'Complaint',
      requiresAuth: true,
      action: 'browes',
      resource: 'Complaint',
      pageTitle: 'Complaint',
      breadcrumb: [
        {
          text: 'Complaint',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/assigned-complaint',
    name: 'assigned-complaint',
    component: () => import('@/views/complaint/AssignedComplaint.vue'),
    meta: {
      title: 'Assigned Complaint',
      requiresAuth: true,
      action: 'browes',
      resource: 'Assigned Complaint',
      pageTitle: 'Assigned Complaint',
      breadcrumb: [
        {
          text: 'Assigned Complaint',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/responsible-complaint',
    name: 'responsible-complaint',
    component: () => import('@/views/complaint/ResponsibleComplaint.vue'),
    meta: {
      title: 'Responsible Complaint',
      requiresAuth: true,
      action: 'browes',
      resource: 'Responsible Complaint',
      pageTitle: 'Responsible Complaint',
      breadcrumb: [
        {
          text: 'Responsible Complaint',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-initial-complaint/:id',
    name: 'admin-initial',
    component: () => import('@/views/complaint/actions-complaint/AdminInitial.vue'),
    meta: {
      title: 'Admin Initial',
      requiresAuth: true,
      action: 'browes',
      resource: 'Admin Initial',
      pageTitle: 'Admin Initial',
      breadcrumb: [
        {
          to: '/index-complaint',
          text: 'Admin Initial',
        },
        {
          text: 'Admin Initial',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/assigned-complaint/:id',
    name: 'add-assigned',
    component: () => import('@/views/complaint/actions-complaint/AddAssigned.vue'),
    meta: {
      title: 'Assigned',
      requiresAuth: true,
      action: 'browes',
      resource: 'Assigned',
      pageTitle: 'Assigned',
      breadcrumb: [
        {
          to: '/index-complaint',
          text: 'Admin Initial',
        },
        {
          text: 'Assigned',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/responsible-complaint/:id',
    name: 'add-responsible',
    component: () => import('@/views/complaint/actions-complaint/AddResponsible.vue'),
    meta: {
      title: 'Responsible',
      requiresAuth: true,
      action: 'browes',
      resource: 'Responsible',
      pageTitle: 'Responsible',
      breadcrumb: [
        {
          to: '/index-complaint',
          text: 'Admin Initial',
        },
        {
          text: 'Responsible',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
]
